import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { useLanguageInitializer } from './hooks';

import NotFound from './pages/notFound';

const Router: React.FC = (): JSX.Element => {
  useLanguageInitializer();

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={<div>Widget</div>}
        />

        <Route
          path="*"
          element={<NotFound />}
        />
      </Routes>
    </>
  );
};

export default Router;
